import { makeAutoObservable } from "mobx";

const DEFAULT_PAGE_SIZE = 20;
const DEFAULT_SORT = { key: "reportingDate", direction: "desc" };

// Filters live in dataEntryFiltersStore. This store only owns the result
// set, pagination, and sort state for the flat overview view.
class OverviewStore {
  items = [];
  total = 0;
  loading = false;
  page = 1;
  pageSize = DEFAULT_PAGE_SIZE;
  sort = DEFAULT_SORT;

  constructor() {
    makeAutoObservable(this);
  }

  setPage = (page) => {
    this.page = page;
  };

  setPageSize = (size) => {
    this.pageSize = size;
    this.page = 1;
  };

  setSort = (sort) => {
    this.sort = { ...this.sort, ...sort };
    this.page = 1;
  };

  setItems = (items, total) => {
    this.items = items;
    this.total = total;
  };

  setLoading = (v) => {
    this.loading = v;
  };

  reset = () => {
    this.items = [];
    this.total = 0;
    this.loading = false;
    this.page = 1;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.sort = DEFAULT_SORT;
  };
}

export const overviewStore = new OverviewStore();
